import { useState } from "react";
import { Stack, Typography } from "@mui/material";
import { LassoTab, LassoTabs } from "../../components/LassoTabs";
import CliInstructions from "./CliInstructions";
import DownloadClient from "./DownloadClient";
import GlobusShare from "./GlobusShare";
import { useGetDownloadClientUrlQuery } from "../../api/awsApiSlice";
import { colours } from "../../StyleConstants";

const DownloadToolsPage = () => {
    const [currentSection, setCurrentSection] = useState("share")
    const { data: urlMac, isFetching } = useGetDownloadClientUrlQuery({ type: "mac" });
    const { data: urlDebian } = useGetDownloadClientUrlQuery({ type: "debian" });
    const { data: urlRedhat } = useGetDownloadClientUrlQuery({ type: "redhat" });
    const cliQueryDownloadClientEnabled = window.env.cliQueryDownloadClientEnabled ?? false;

    const handleTabChange = (event: React.SyntheticEvent, newTab: string) => {
        switch (newTab) {
        case "client":
            setCurrentSection('client');
            break;
        case "share":
            setCurrentSection('share');
            break;
        case "cli":
            setCurrentSection('cli');
            break;
        }
    }

    const renderSections = () => {
        switch (currentSection) {
        case 'client':
            return (<DownloadClient urls={{ mac: urlMac?.url, debian: urlDebian?.url, redhat: urlRedhat?.url }} isLoading={isFetching}/>)
        case 'share':
            return (<GlobusShare/>)
        case 'cli':
            return (<CliInstructions/>)
        }
    }

    if (!cliQueryDownloadClientEnabled) {
        return (
            <>
                <Typography
                    variant="h1"
                    fontWeight="600"
                    fontSize="2.125rem"
                    color={colours.midnightBlue.blue}>
                    Globus Share
                </Typography>

                <GlobusShare/>
            </>
        )
    }

    return(
        <Stack
            flexDirection= "column"
            gap={3}
            overflow="auto"
            height="100%">

            <LassoTabs value={currentSection}  onChange={handleTabChange}>
                <LassoTab label="GLOBUS SHARE" value="share"/>
                <LassoTab label={
                    <Stack>
                        <Typography color="grey">
                            DOWNLOAD CLIENT
                        </Typography>
                        <Typography color="red" fontSize="0.75rem">
                            (COMING SOON)
                        </Typography>
                    </Stack>}
                value="client" disabled={true}/>

                <LassoTab label={
                    <Stack>
                        <Typography color="grey">
                            CLI QUERY TOOL
                        </Typography>
                        <Typography color="red" fontSize="0.75rem">
                            (Coming Soon)
                        </Typography>
                    </Stack>}
                value="cli" disabled={true}/>
            </LassoTabs>
            {renderSections()}
        </Stack>
    )
}


export default DownloadToolsPage;